<template>
    <div class="btn-properties" v-on="$listeners" :class="[{ 'selected': selected}]">
        <slot></slot>
    </div>
</template>

<script>

export default {
    name: `btn-properties`,
    props: {
        selected: {type: Boolean}
    }
}
</script>

<style lang="scss" scoped>
.btn-properties {
    height: 44px;
    width: 70px;
    margin-right: 3px;
    margin-bottom: 3px;
    overflow: hidden;

    &:hover {
        border-color: var(--color-accent);
    }

    &.selected {
        transform: scale(0.95);
        border-color: var(--color-accent);
    }
}
</style>
